/**
 * File that gathers all the steps and by default exports the array of them in the given order.
 * Some of the steps are also exported individually to easily access the step identifier,
 * for example by the left menu to set correct data-oid attributes.
 */
import TeamMembersStep from './TeamMembersStep';
import CreateBrandspaceStep from './CreateBrandspaceStep';
import CongratulationsStep from './CongratulationsStep';

export default [
	TeamMembersStep,
	CreateBrandspaceStep,
	CongratulationsStep
];

export {
	TeamMembersStep,
	CreateBrandspaceStep
};


// WEBPACK FOOTER //
// ./src/containers/OnBoarding/Steps/index.js